/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResultFreshness } from './result-freshness';


export interface RunQueryResponseDto { 
    /**
     * True when the rows came from the query-result cache instead of a warehouse run.
     */
    cacheHit?: boolean;
    /**
     * Warehouse run time in milliseconds once the query finished. Absent on a cache hit.
     */
    durationMs?: number;
    /**
     * Milliseconds since the warehouse run started, while it is still running.
     */
    elapsedMs?: number;
    /**
     * True when the run took 5 s or more: tell the user how long it takes and what that means on a dashboard, and try a narrower period while revising it. Absent on a cache hit.
     */
    slow?: boolean;
    /**
     * QUERY_TIMEOUT when the warehouse stopped the query at the statement cap (60 s for dashboard tiles, 180 s for agent queries); narrow the date range or group by fewer values. QUERY_CANCELLED, with status cancelled, when the warehouse cancelled the query on request; run it again.
     */
    errorCode?: RunQueryResponseDto.ErrorCodeEnum;
    /**
     * fresh: computed inside the cache window. stale: an older result served at once while one background refresh runs; show computedAt. computing: the query is still queued or running.
     */
    freshness?: ResultFreshness;
    /**
     * When the rows were computed, for an \"as of\" label.
     */
    computedAt?: string;
    /**
     * Queued query execution id to poll through the results endpoint.
     */
    executionId: string;
    /**
     * Status after the requested waitMs: success or error means getQueryResults answers at once; pending or running means poll it.
     */
    status?: RunQueryResponseDto.StatusEnum;
}
export namespace RunQueryResponseDto {
    export const ErrorCodeEnum = {
        QueryTimeout: 'QUERY_TIMEOUT',
        QueryCancelled: 'QUERY_CANCELLED'
    } as const;
    export type ErrorCodeEnum = typeof ErrorCodeEnum[keyof typeof ErrorCodeEnum];
    export const StatusEnum = {
        Error: 'error',
        Pending: 'pending',
        Running: 'running',
        Success: 'success',
        Generating: 'generating',
        Cancelled: 'cancelled'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


